module.exports = __webpack_public_path__ + "img/00010.8b421cca.webp";